import { StyleRulesCallback, colors } from '@material-ui/core';

export const errorTooltipStyles: StyleRulesCallback = () => ({
    tooltip: {
        backgroundColor: colors.red[600],
    },
});
